import { ReactNode, createContext } from 'react'

export type Translator = (key: string, replacements?: string[], overrideLang?: string) => string

export type HasTranslation = (key: string) => boolean

export interface TranslationContextType {
  t: Translator
  hasTranslation: HasTranslation
}

export const TranslationContext = createContext<TranslationContextType>({
  t: key => key,
  hasTranslation: () => false,
})

export type TranslationProviderProps = {
  t: Translator
  children: ReactNode
  hasTranslation: HasTranslation
}

export function TranslationProvider(props: TranslationProviderProps) {
  const { t, children, hasTranslation } = props
  return <TranslationContext.Provider value={{ t, hasTranslation }}>{children}</TranslationContext.Provider>
}
